module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_12_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_12_before.jpg
// module id = 1180
// module chunks = 0